import type {Theme, Components} from "../..";

type InputLabelOverrides = Components<Theme>["MuiInputLabel"];

const overrides: InputLabelOverrides = {
    styleOverrides: {
        root: {
            "&:not(.MuiInputLabel-shrink)": {
                transform: "translate(14px, 12px) scale(1)",
            },
        },
        outlined: ({theme}) => ({
            ...theme.typography.body2,
            color: theme.color.text.subtlest,

            "&.Mui-focused": {
                color: theme.color.text.interactive,
            },

            "&.Mui-disabled": {
                color: theme.color.text.disabled,
            },

            "&:not(.MuiInputLabel-shrink).Mui-error": {
                color: theme.color.text.subtlest,
            },

            "&.MuiInputLabel-shrink.Mui-error": {
                color: theme.color.text.critical,
            },
        }),
    },
};

export default overrides;
